<template>
  <CmStateCard
    :isLoading="isLoading"
    :isError="isError"
    :isEmpty="!value || (value && !value.length)"
    class="cm-state-card--grouped-bar"
  >
    <CmGroupedBar
      mainKey="date"
      :labels="labels"
      :value="value"
    />
  </CmStateCard>
</template>

<script>
import CmStateCard from '@/components/library/statistics/cards/CmStateCard.vue';
import CmGroupedBar from "@/components/library/statistics/elements/CmGroupedBar";
import { mapState } from "vuex";

export default {
  components: {
    CmStateCard,
    CmGroupedBar,
  },

  data() {
    return {
      labels: {
        delivered: "Доставлено",
        // opened: "Открыто",
        unsubscribed: "Отписались",
      },
    };
  },

  computed: {
    ...mapState({
      isLoading: state => state.stat.loadings.details,
      isError: state => state.stat.errors.details,
    }),
    value() {
      return this.formData(this.$store.getters.getDetails);
    },
  },

  methods: {
    formData(arr) {
      return arr.map(i => {
        const { date, opened, unsubscribed, delivered } = i;

        return {
          date,
          opened,
          unsubscribed,
          delivered,
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.cm-state-card--grouped-bar {
  max-width: 670px;
}
</style>
